import toast, { ToastOptions } from 'react-hot-toast';
import BaseToastContainer from '@app/components/BaseToastContainer';

export type ShowToastCommand = {
  message: string;
  configs?: ToastOptions;
  mode: 'error' | 'success' | 'warning';
};

export const DEFAULT_CONFIGS: ToastOptions = {
  duration: 5000,
  position: 'bottom-right',
  style: { padding: 0, boxShadow: 'none', background: 'none' },
};

export default function onShowToast({ translator }) {
  return function ({ mode, message = '', configs }: ShowToastCommand) {
    const configurations = { ...DEFAULT_CONFIGS, ...configs };
    if (mode === 'error') toast(t => <BaseToastContainer type="error" message={message.trim()} toastId={t.id} />, configurations);
    if (mode === 'success') toast(t => <BaseToastContainer type="success" message={message.trim()} toastId={t.id} />, configurations);
    if (mode === 'warning') toast(t => <BaseToastContainer type="warning" message={message.trim()} toastId={t.id} />, configurations);
  };
}
